import { Easing, interpolate, tween } from '../hint-motion';

/**
 * Gemeinsame Bausteine der Portal-Hinweis-Filme — dieselben Werte wie die
 * Claude-Design-Entwürfe (Glass, Pressed, Cursor, Symbole, MOTION, Bühne),
 * als HTML-Strings für `mount` und kleine Helfer für `render`.
 */

export const C = {
  text: '#243650',
  muted: '#526581',
  icon: '#536d91',
  action: '#2563EB',
  hover: '#1D4ED8',
  accent: '#3B82F6',
  ok: '#00A35C',
  okInk: '#00786F',
};

export const DIVIDER_H = 'linear-gradient(to bottom, rgb(52 76 117 / .17) 0 1px, rgb(255 255 255 / .78) 1px 2px)';
export const DIVIDER_V = 'linear-gradient(to right, rgb(52 76 117 / .17) 0 1px, rgb(255 255 255 / .78) 1px 2px)';
export const PRESSED =
  'background: linear-gradient(135deg, rgb(75 108 162 / .10), rgb(229 240 255 / .08));' +
  'box-shadow: inset 3px 4px 7px rgb(47 76 121 / .20), inset -3px -3px 6px rgb(255 255 255 / .88), 0 1px 0 rgb(255 255 255 / .60);';
export const FIELD_SHADOW = 'inset 0 4px 6px -3px rgb(47 76 121 / .23), inset 0 -4px 6px -3px rgb(255 255 255 / .90)';

/** Die drei Bewegungen der Entwürfe — keine andere Kurve im Stück. */
export const MOTION = {
  enter: (a: number, b: number, t: number) => tween(a, b, t, Easing.easeOutCubic),
  glide: (a: number, b: number, t: number) => tween(a, b, t, Easing.easeInOutCubic),
  path: (keys: number[], vals: number[], t: number) => interpolate(keys, vals, Easing.easeInOutCubic)(t),
};

const ICONS: Record<string, string> = {
  agent: '<circle cx="12" cy="12" r="9"/><path d="M9.5 10.5v2M14.5 10.5v2"/>',
  brain:
    '<path d="M12 4c-1-2-4-1.5-4.5.7-2.5-.3-4.3 2-3.3 4.2-2.4 1.2-2.2 4.7-.3 5.5-1.3 2.3.3 4.8 2.5 4.7.5 3 4.3 3.2 5.6.9m0-16c1-2 4-1.5 4.5.7 2.5-.3 4.3 2 3.3 4.2 2.4 1.2 2.2 4.7.3 5.5 1.3 2.3-.3 4.8-2.5 4.7-.5 3-4.3 3.2-5.6.9V4Z"/><path d="M5 9c2-.6 3 .1 3.5 1.5M4.5 15c2-1 4-.1 4.4 1.8M19 9c-2-.6-3 .1-3.5 1.5M19.5 15c-2-1-4-.1-4.4 1.8"/>',
  brush:
    '<path d="m9.5 14.5 8.7-10.7c1.8-2.1 4-1.1 2.7 1.4l-7.2 12"/><path d="M9.4 14.5c-2.9-1.1-4.8.9-4.5 3C5 19 4 20 2.5 20.5c4.7 2.2 9.3.8 10.7-2.8Z"/>',
  book: '<path d="M12 5.7C9 4 5.4 3.9 3 4.8v14c2.4-.9 6-.8 9 .9m0-14c3-1.7 6.6-1.8 9-.9v14c-2.4-.9-6-.8-9 .9m0-14v14"/>',
  template: '<path d="M2 8.5 12 3l10 5.5L12 14 2 8.5Z"/><path d="M6 11v6c2.7 3 9.3 3 12 0v-6M22 9v8"/>',
  sliders: '<path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/>',
  courses: '<path d="M7 7V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-2"/><rect x="3" y="7" width="14" height="14" rx="2"/>',
  folder: '<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z"/>',
  folderOpen: '<path d="M3 10V6a2 2 0 0 1 2-2h4l2 3h8a2 2 0 0 1 2 2v1M3 10h18l-2 10H5Z"/>',
  search: '<circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  file: '<path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Z"/><path d="M14 3v6h6M8 13h8M8 17h6"/>',
  globe: '<circle cx="12" cy="12" r="9"/><ellipse cx="12" cy="12" rx="4" ry="9"/><path d="M3 12h18"/>',
  check: '<path d="m5 12.5 4.5 4.5L19 7.5"/>',
  bell: '<path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15Z"/><path d="M10 20.5a2 2 0 0 0 4 0"/>',
  card: '<rect x="3" y="5.5" width="18" height="13" rx="2.5"/><path d="M3 10h18M7 15h3"/>',
  users: '<circle cx="9" cy="8.5" r="3.2"/><path d="M3.5 19c.6-3.2 2.8-5 5.5-5s4.9 1.8 5.5 5"/><path d="M15.5 5.6a3 3 0 0 1 0 5.8M17.5 14.4c1.6.6 2.7 2.2 3 4.6"/>',
  plug: '<path d="M9 3v5M15 3v5"/><path d="M6 8h12v3a6 6 0 0 1-12 0Z"/><path d="M12 17v4"/>',
  chart: '<path d="M3 20h18"/><path d="M6 16v-5M11 16V6M16 16v-8M20 16v-3"/>',
  logout: '<path d="M14 4H6.5A1.5 1.5 0 0 0 5 5.5v13A1.5 1.5 0 0 0 6.5 20H14"/><path d="M10 12h10M16.5 8.5 20 12l-3.5 3.5"/>',
  dot: '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="3"/>',
  gear: '<circle cx="12" cy="12" r="3"/><path d="M12 2.8v2.4M12 18.8v2.4M2.8 12h2.4M18.8 12h2.4M5.5 5.5l1.7 1.7M16.8 16.8l1.7 1.7M5.5 18.5l1.7-1.7M16.8 7.2l1.7-1.7"/><circle cx="12" cy="12" r="6.2"/>',
  searchTab: '<circle cx="11" cy="11" r="6.5"/><path d="m16 16 4.5 4.5"/>',
  close: '<path d="M6 6l12 12M18 6 6 18"/>',
  help: '<circle cx="12" cy="12" r="9"/><path d="M9.6 9.4a2.5 2.5 0 0 1 4.8.8c0 1.7-2.4 2-2.4 3.6M12 17h.01"/>',
  chevron: '<path d="m6 9 6 6 6-6"/>',
  lock: '<rect x="5" y="10.5" width="14" height="10" rx="2.2"/><path d="M8.5 10.5V7.5a3.5 3.5 0 0 1 7 0v3"/>',
  send: '<path d="M4 12 20 4l-5 16-3.5-6.5Z"/><path d="m11.5 13.5 8.5-9.5"/>',
  award: '<circle cx="12" cy="9" r="6"/><path d="m8.5 13.8-1.5 7.2 5-2.6 5 2.6-1.5-7.2"/>',
  play: '<path d="M8 5.5v13l10.5-6.5Z"/>',
  thumbDown: '<path d="M10 15.5 9 20a2 2 0 0 0 2 2l4.5-8V3.5H7.2a2 2 0 0 0-2 1.7l-1.2 7.6a2 2 0 0 0 2 2.3Z"/><path d="M15.5 3.5h3v10.5h-3"/>',
  chat: '<path d="M4 5.5h16v10.5H9l-5 4Z"/>',
  image: '<rect x="3.5" y="4.5" width="17" height="15" rx="2.5"/><circle cx="9" cy="10" r="1.8"/><path d="m4 17.5 5-4.5 4 3.5 3-2.5 4.5 3.5"/>',
};

export function icon(name: string, size = 18, color = C.icon, stroke = 1.8, style = ''): string {
  if (name === 'agent') return orbiIcon(size, color, style);
  return (
    `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="${stroke}" ` +
    `stroke-linecap="round" stroke-linejoin="round" style="display:block;flex:0 0 auto;${style}">${ICONS[name]}</svg>`
  );
}

export const abs = (x: number, y: number, w: number, h: number, extra = '') =>
  `position:absolute;left:${x}px;top:${y}px;width:${w}px;height:${h}px;${extra}`;

/** Portal-CI-Glas wie `Glass` im Entwurf; `inner` liegt über dem Material,
 *  `attrs` landet am äußeren Element (z. B. `data-r="…"` für bewegte Gläser). */
export function glass(radius: number, opacity: number, style: string, inner: string, attrs = ''): string {
  return (
    `<div ${attrs} style="position:absolute;border-radius:${radius}px;color:${C.text};` +
    `background:linear-gradient(160deg, rgb(255 255 255 / .085), rgb(255 255 255 / .022) 30%, transparent 56%, rgb(255 255 255 / .035)), rgb(255 255 255 / ${opacity});` +
    `backdrop-filter:blur(22px) saturate(1.06);-webkit-backdrop-filter:blur(22px) saturate(1.06);` +
    `box-shadow:7px 18px 30px -16px rgb(38 65 112 / .24), 0 4px 8px -5px rgb(38 65 112 / .15);${style}">` +
    `<div style="position:absolute;inset:0;border-radius:inherit;opacity:.92;pointer-events:none;` +
    `background:radial-gradient(ellipse at 0% 0%, rgb(255 255 255 / .15), transparent 43%), radial-gradient(ellipse at 100% 100%, rgb(255 255 255 / .085), transparent 40%);` +
    `box-shadow:inset 0 1px 2px rgb(255 255 255 / .42), inset 1px 0 2px rgb(255 255 255 / .26), inset 0 -1.5px 2px rgb(255 255 255 / .72), inset 0 0 28px rgb(255 255 255 / .30), inset 0 18px 27px -17px rgb(255 255 255 / .72), inset 0 -20px 23px -15px rgb(255 255 255 / .92);"></div>` +
    `<div style="position:absolute;inset:0;border-radius:inherit;box-shadow:inset 0 0 0 1px rgb(255 255 255 / .7);pointer-events:none;"></div>` +
    `<div style="position:absolute;inset:0;">${inner}</div></div>`
  );
}

/** Relief-Plakette mit Ordnersymbol (Standard 34px); `a`/`b` = zwei überblendbare Symbole. */
export function reliefFolder(a: string, b: string, size = 34): string {
  return (
    `<div style="position:relative;width:${size}px;height:${size}px;border-radius:10px;flex:0 0 auto;` +
    `background:radial-gradient(ellipse at 10% 0%, rgb(255 255 255 / .73), transparent 70%), linear-gradient(145deg, rgb(239 247 255 / .52), rgb(152 189 237 / .20) 68%, rgb(233 245 255 / .44));` +
    `box-shadow:inset 1px 1px 1px rgb(255 255 255 / .94), inset -1px -1px 2px rgb(242 250 255 / .65), 2px 3px 4px rgb(67 105 163 / .12), 4px 5px 8px -5px rgb(53 92 148 / .18);">` +
    `<div style="position:absolute;inset:7px;filter:drop-shadow(-.6px -.8px .25px rgb(255 255 255 / .98)) drop-shadow(.7px 1.1px .35px rgb(32 65 111 / .50));">` +
    a +
    b +
    `</div></div>`
  );
}


/**
 * Orbi, wie er im Portal aussehen muss — zwei Formen, beide aus den
 * finalen Exporten (`Agent_Creation/Orbi_Exports_Final/Orbi_schraeg/`):
 *  - `orbi3d`: die Figur (`3D/orbi-end-3d.svg`) — überall, wo Orbi auftritt
 *    (Intro, Kachel, Chat, Jubel).
 *  - `orbiIcon`: das Symbol (`Orbi_ICON_outline_up.svg`) — Knopf des
 *    internen Agenten in der Kopfzeile und Menüpunkt „KI-Agenten".
 * Keine eigene Kugel mit senkrechten Augen mehr — das war nicht Orbi.
 */
const ORBI_EYE_A =
  'M29.3966 30.8752C27.3653 27.6109 28.8854 23.3052 32.5158 22.0396L33.1046 21.8344C35.7579 20.9095 38.6977 21.9499 40.1787 24.3379L41.2244 26.0241C43.053 28.9729 44.2206 32.283 44.6466 35.7265L44.936 38.0667C45.283 40.8717 43.6253 43.5386 40.9564 44.4689L40.4019 44.6622C36.7715 45.9278 32.9042 43.5001 32.466 39.6804L32.434 39.4011C32.0965 36.4589 31.1098 33.6284 29.5451 31.1139L29.3966 30.8752Z';
const ORBI_EYE_B =
  'M44.6725 24.0604C43.0872 21.5374 44.1537 18.1947 46.9073 17.0559C49.0909 16.1529 51.607 16.9695 52.8441 18.9827L54.766 22.1101C56.545 25.0051 57.8192 28.1812 58.5343 31.503L59.0006 33.6687C59.4941 35.9615 58.2778 38.2792 56.1105 39.1755C53.3322 40.3245 50.1882 38.697 49.5224 35.7651L48.9354 33.1803C48.3857 30.7599 47.4304 28.4499 46.1099 26.3482L44.6725 24.0604Z';
const ORBI_GLINTS =
  '<circle cx="31.747" cy="28.375" r="1.56246" transform="rotate(-19.2182 31.747 28.375)" fill="white"/>' +
  '<circle cx="35.0633" cy="29.9765" r="1.04164" transform="rotate(-19.2182 35.0633 29.9765)" fill="white"/>' +
  '<ellipse cx="1.43344" cy="1.57024" rx="1.43344" ry="1.57024" transform="matrix(0.931119 -0.364715 0.296304 0.955094 45 21.0452)" fill="white"/>' +
  '<ellipse cx="0.955627" cy="1.04683" rx="0.955627" ry="1.04683" transform="matrix(0.931119 -0.364715 0.296304 0.955094 48.6001 22.9998)" fill="white"/>';

let orbiUid = 0;

/** Orbi-Symbol (Outline), quadratisch `size`; Linie und Augen in `color`. */
export function orbiIcon(size: number, color = '#253551', style = ''): string {
  return (
    `<svg width="${size}" height="${size}" viewBox="6 6 66 66" fill="none" style="display:block;flex:0 0 auto;${style}">` +
    `<path d="M66.1373 29.2572C71.4023 44.3606 63.4266 60.8724 48.3233 66.1373C33.2199 71.4023 16.7081 63.4266 11.4432 48.3233C6.17824 33.2199 14.1539 16.7081 29.2572 11.4432C44.3606 6.17824 60.8724 14.1539 66.1373 29.2572Z" fill="white" stroke-width="4" stroke="${color}"/>` +
    `<path d="${ORBI_EYE_A}" fill="${color}"/><path d="${ORBI_EYE_B}" fill="${color}"/>` +
    ORBI_GLINTS +
    `</svg>`
  );
}

/**
 * 3D-Orbi als SVG (Ausschnitt um die Kugel, 61×61 von 78). Drei Gesichter
 * übereinander, gemalt von `paintOrbiFace`: schräge Augen (`eyesRef`, Ruhe —
 * Orbi schaut nach oben rechts), frontale Augen (`frontRef`) und lachende
 * Bögen (`smileRef`). Ohne Refs bleibt nur der schräge Blick.
 */
export function orbi3d(size: number, eyesRef = '', smileRef = '', frontRef = ''): string {
  const u = `o3d${++orbiUid}`;
  const id = (n: string) => `${u}-${n}`;
  const shadow = (shape: string) => `<g opacity="0.22" filter="url(#${id('soft')})" transform="translate(0.9 1.4)">${shape.replace('FILL', '#3b2f6e')}</g>${shape.replace('FILL', `url(#${id('iris')})`)}`;
  const frontEye = (cx: number) =>
    shadow(`<ellipse cx="${cx}" cy="${ORBI_FRONT.y}" rx="5.8" ry="11.2" fill="FILL"/>`) +
    `<circle cx="${cx - 2}" cy="${ORBI_FRONT.y - 5.4}" r="1.9" fill="white"/><circle cx="${cx + 1.2}" cy="${ORBI_FRONT.y - 2.6}" r="1.15" fill="white"/>`;
  const arc = (cx: number) => `<path d="M${cx - 5} ${ORBI_FRONT.y + 2} Q${cx} ${ORBI_FRONT.y - 7.6} ${cx + 5} ${ORBI_FRONT.y + 2}"/>`;
  return (
    `<svg width="${size}" height="${size}" viewBox="8.3 8.3 61 61" fill="none" style="display:block;overflow:visible;">` +
    `<defs>` +
    `<radialGradient id="${id('body')}" cx="0.34" cy="0.27" r="0.82"><stop offset="0" stop-color="#ffffff"/><stop offset="0.3" stop-color="#f7f8fd"/><stop offset="0.6" stop-color="#dfe3f2"/><stop offset="0.85" stop-color="#bcc2de"/><stop offset="1" stop-color="#a3aacf"/></radialGradient>` +
    `<radialGradient id="${id('core')}" cx="0.78" cy="0.86" r="0.55"><stop offset="0" stop-color="#5d6597" stop-opacity="0.32"/><stop offset="1" stop-color="#5d6597" stop-opacity="0"/></radialGradient>` +
    `<radialGradient id="${id('rim')}" cx="0.5" cy="0.5" r="0.5"><stop offset="0.82" stop-color="#b3a9f2" stop-opacity="0"/><stop offset="0.95" stop-color="#b3a9f2" stop-opacity="0.3"/><stop offset="1" stop-color="#8f84e4" stop-opacity="0.5"/></radialGradient>` +
    `<radialGradient id="${id('bounce')}" cx="0.66" cy="1.02" r="0.4"><stop offset="0" stop-color="#ffd9ea" stop-opacity="0.85"/><stop offset="1" stop-color="#ffd9ea" stop-opacity="0"/></radialGradient>` +
    `<radialGradient id="${id('spec')}" cx="0.5" cy="0.5" r="0.5"><stop offset="0" stop-color="#ffffff" stop-opacity="1"/><stop offset="1" stop-color="#ffffff" stop-opacity="0"/></radialGradient>` +
    `<linearGradient id="${id('iris')}" x1="0.3" y1="0" x2="0.7" y2="1"><stop offset="0" stop-color="#3a4d78"/><stop offset="1" stop-color="#1a2440"/></linearGradient>` +
    `<filter id="${id('soft')}" x="-30%" y="-30%" width="160%" height="160%"><feGaussianBlur stdDeviation="1.1"/></filter>` +
    `</defs>` +
    ['body', 'core', 'bounce', 'rim'].map((g) => `<circle cx="38.7902" cy="38.7902" r="30.461" fill="url(#${id(g)})"/>`).join('') +
    `<ellipse cx="25.5" cy="19.8" rx="10.5" ry="6.4" transform="rotate(-34 25.5 19.8)" fill="url(#${id('spec')})"/>` +
    `<ellipse cx="22.6" cy="18.6" rx="2.3" ry="1.3" transform="rotate(-34 22.6 18.6)" fill="#ffffff" opacity="0.9"/>` +
    `<g ${eyesRef ? `data-r="${eyesRef}"` : ''}>` +
    [ORBI_EYE_A, ORBI_EYE_B].map((d) => shadow(`<path d="${d}" fill="FILL"/>`)).join('') +
    ORBI_GLINTS +
    `</g>` +
    (frontRef
      ? `<g data-r="${frontRef}" opacity="0">${frontEye(ORBI_FRONT.x - ORBI_FRONT.gap)}${frontEye(ORBI_FRONT.x + ORBI_FRONT.gap)}</g>`
      : '') +
    // Lachen: die frontalen Augen werden zu Bögen (kein Mund — wie im Orbi-Lab).
    (smileRef
      ? `<g data-r="${smileRef}" fill="none" stroke="url(#${id('iris')})" stroke-width="3.8" stroke-linecap="round" opacity="0">${arc(ORBI_FRONT.x - ORBI_FRONT.gap)}${arc(ORBI_FRONT.x + ORBI_FRONT.gap)}</g>`
      : '') +
    `</svg>`
  );
}

/** Mitte des frontalen Blicks (Kugelmitte, etwas angehoben) und halber Augenabstand. */
const ORBI_FRONT = { x: 38.8, y: 37.4, gap: 8.6 };
/** Mitte des schrägen Augenpaars — von hier dreht der Kopf zur Mitte. */
const ORBI_SIDE = { x: 44.1, y: 30.8, tilt: -20 };

/** Dauer (Autorenzeit) von „Kopf zur Mitte → frontal → zweimal blinzeln“ in `paintOrbiFace`. */
export const ORBI_FACE_SECONDS = 0.85;

const smooth = (v: number) => {
  const x = Math.min(1, Math.max(0, v));
  return x * x * (3 - 2 * x);
};

/** Zwei Lidschläge in `paintOrbiFace` (Anteil an `face`): zu und wieder auf. */
const ORBI_BLINKS: [number, number][] = [
  [0.56, 0.68],
  [0.74, 0.86],
];

/**
 * Malt Orbis Gesicht für `face` 0…1: bis 0,45 dreht der Kopf zur Mitte (das
 * schräge Augenpaar wandert zur Kugelmitte und richtet sich auf, in fast
 * gleicher Größe — am Ende gehen die Augen in die frontalen über), dann
 * schaut er frontal und blinzelt zweimal; die Augen bleiben am Ende offen.
 * Gibt die Freude 0…1 zurück (für den Hüpfer). `smile` bleibt aus.
 */
export function paintOrbiFace(eyes: Element[] = [], front: Element[] = [], smile: Element[] = [], face: number): number {
  // Weich ein- und auslaufen (smootherstep); die Augen behalten beim Schwenk
  // ihre Größe — nur ein Hauch Verkürzung, und der Wechsel auf die frontalen
  // Augen passiert erst, wenn die schrägen schon fast aufrecht stehen.
  const x = Math.min(1, Math.max(0, face / 0.45));
  const turn = x * x * x * (x * (6 * x - 15) + 10);
  const cross = smooth((turn - 0.7) / 0.28);
  const sx = 1 - 0.05 * Math.sin(Math.PI * turn);
  const dx = ORBI_FRONT.x - ORBI_SIDE.x;
  const dy = ORBI_FRONT.y - ORBI_SIDE.y;
  const around = (cx: number, cy: number, rot: number) => `translate(${cx} ${cy}) rotate(${rot}) scale(${sx} 1) translate(${-cx} ${-cy})`;
  for (const el of eyes) {
    el.setAttribute('transform', `translate(${dx * turn} ${dy * turn}) ${around(ORBI_SIDE.x, ORBI_SIDE.y, -ORBI_SIDE.tilt * turn)}`);
    el.setAttribute('opacity', String(1 - cross));
  }
  const lid = Math.max(0, ...ORBI_BLINKS.map(([a, b]) => (face > a && face < b ? Math.sin((Math.PI * (face - a)) / (b - a)) : 0)));
  const open = 1 - 0.9 * lid;
  for (const el of front) {
    el.setAttribute(
      'transform',
      `translate(${-dx * (1 - turn)} ${-dy * (1 - turn)}) ${around(ORBI_FRONT.x, ORBI_FRONT.y, ORBI_SIDE.tilt * (1 - turn))} ` +
        `translate(0 ${ORBI_FRONT.y + 4}) scale(1 ${open}) translate(0 ${-ORBI_FRONT.y - 4})`,
    );
    el.setAttribute('opacity', String(cross));
  }
  for (const el of smile) el.setAttribute('opacity', '0');
  return smooth((face - 0.45) / 0.45);
}

/** Orbi (3D) auf `size` skaliert, lacht und hüpft über `renderOrbi`. Refs mit `prefix`. */
export function orbiTemplate(prefix: string, size: number, wrapStyle = ''): string {
  return (
    `<div data-r="${prefix}Wrap" style="position:relative;width:${size}px;height:${size}px;flex:0 0 auto;${wrapStyle}">` +
    `<div data-r="${prefix}Lift" style="position:absolute;inset:0;">` +
    `<div data-r="${prefix}Ball" style="position:absolute;inset:0;border-radius:999px;box-shadow:0 6px 12px -6px rgb(38 65 112 / .35);"></div>` +
    `<div style="position:absolute;inset:0;">${orbi3d(size, `${prefix}Eye`, `${prefix}Smile`, `${prefix}Front`)}</div>` +
    `</div></div>`
  );
}

/**
 * Malt Orbi aus `orbiTemplate`: `face` 0…1 = Kopf zur Mitte → frontal →
 * zweimal blinzeln (`paintOrbiFace`, über `ORBI_FACE_SECONDS` laufen lassen), Hüpfer `pop`.
 */
export function renderOrbi(refs: Refs, prefix: string, face: number, pop: number): void {
  const laugh = paintOrbiFace(refs[`${prefix}Eye`], refs[`${prefix}Front`], refs[`${prefix}Smile`], face);
  const lift = -3 * laugh * Math.abs(Math.sin(Math.PI * 3 * laugh)) - 2.5 * pop;
  refs[`${prefix}Lift`][0].style.transform = `translateY(${lift}px) scale(${1 + 0.06 * pop})`;
  refs[`${prefix}Ball`][0].style.boxShadow =
    `0 6px 12px -6px rgb(38 65 112 / .35), 0 0 ${14 * pop}px rgb(143 132 228 / ${0.5 * pop})`;
}

const ARROW = '1,1 1,19 5.6,15 8.8,22.2 11.8,20.9 8.7,13.9 14.6,13.9';

/** 3D-Pfeil mit Klick-Ring; Refs `ring` und `arrow`. `uid` hält die SVG-ids eindeutig. */
export function cursorTemplate(uid: string): string {
  const depth = [3, 2.5, 2, 1.5, 1, 0.5];
  return (
    `<div data-r="ring" style="position:absolute;width:14px;height:14px;border-radius:999px;opacity:0;"></div>` +
    `<svg data-r="arrow" width="30" height="34" viewBox="0 0 24 27" style="position:absolute;overflow:visible;transform-origin:1.25px 1.25px;">` +
    `<defs><linearGradient id="${uid}-face" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#ffffff"/><stop offset="0.55" stop-color="#f1f2f4"/><stop offset="1" stop-color="#c9ccd2"/></linearGradient>` +
    `<linearGradient id="${uid}-side" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#3a3d44"/><stop offset="1" stop-color="#08090b"/></linearGradient>` +
    `<filter id="${uid}-shadow" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="1.6"/></filter></defs>` +
    `<polygon points="${ARROW}" transform="translate(4.5 6)" fill="rgb(36 54 80 / .28)" filter="url(#${uid}-shadow)"/>` +
    depth
      .map(
        (d) =>
          `<polygon points="${ARROW}" transform="translate(${d * 0.8} ${d * 0.6})" fill="url(#${uid}-side)" stroke="#08090b" stroke-width="0.9" stroke-linejoin="round"/>`,
      )
      .join('') +
    `<polygon points="${ARROW}" fill="url(#${uid}-face)" stroke="#0b0c0f" stroke-width="1.1" stroke-linejoin="round"/>` +
    `<polygon points="2.6,4.2 2.6,9.5 7.5,7.6" fill="#fff" opacity="0.8"/></svg>`
  );
}

export function renderCursor(ring: HTMLElement, arrow: HTMLElement, x: number, y: number, press: number, r: number): void {
  ring.style.left = `${x - 7}px`;
  ring.style.top = `${y - 7}px`;
  ring.style.boxShadow = `0 0 0 ${r * 16}px rgb(59 130 246 / ${0.3 * (1 - r)})`;
  ring.style.opacity = r > 0 && r < 1 ? '1' : '0';
  arrow.style.left = `${x - 1.25}px`;
  arrow.style.top = `${y - 1.25}px`;
  arrow.style.transform = `scale(${1 - 0.15 * press})`;
}

/** Klick zur Zeit `at`: Druck (0…1…0) und Ring (0→1). */
export function click(at: number, T: number): { press: number; ring: number } {
  const down = MOTION.enter(at - 0.04, at + 0.03, T);
  const up = MOTION.enter(at + 0.05, at + 0.17, T);
  return { press: down * (1 - up), ring: Math.max(0, Math.min(1, (T - at) / 0.36)) };
}

const BACKDROP =
  'background-color:#f6f8ff;background-image:radial-gradient(ellipse at 0% 37%, rgb(59 130 246 / .24), transparent 61%), radial-gradient(ellipse at 81% 0%, rgb(255 126 175 / .22), transparent 54%), radial-gradient(ellipse at 40% 65%, rgb(180 127 255 / .17), transparent 59%), radial-gradient(ellipse at 100% 93%, rgb(255 175 133 / .23), transparent 57%), radial-gradient(ellipse at 70% 20%, rgb(255 128 147 / .08), transparent 65%);';

/** Bühne 640×354 mit Portal-Verlauf und Kamera-Ebene (Ref `camera`, 640×400).
 *  `fixed` liegt unter der Kamera und bewegt sich nicht mit (z. B. Titelschrift). */
export function stage(cameraContent: string, fixed = ''): string {
  return (
    `<div style="position:absolute;inset:0;overflow:hidden;color:${C.text};${BACKDROP}">` +
    fixed +
    `<div style="${abs(0, 0, 640, 354, 'overflow:hidden;')}">` +
    `<div data-r="camera" style="position:absolute;left:0;top:0;width:640px;height:400px;transform-origin:0 0;">` +
    cameraContent +
    `</div></div></div>`
  );
}

export function renderCamera(camera: HTMLElement, fx: number, fy: number, s: number): void {
  camera.style.transform = `translate(${320 - fx * s}px, ${176 - fy * s}px) scale(${s})`;
}

export type Refs = Record<string, HTMLElement[]>;

/** Baut `html` in `host` und sammelt alle `[data-r]` nach Namen. */
export function mountTemplate(host: HTMLElement, html: string): Refs {
  host.innerHTML = html;
  const refs: Refs = {};
  host.querySelectorAll<HTMLElement>('[data-r]').forEach((el) => {
    (refs[el.dataset['r']!] ??= []).push(el);
  });
  return refs;
}

let uidCounter = 0;
export const nextUid = (prefix: string) => `${prefix}-${++uidCounter}`;
